import React from "react";
import LoadingBoundary from "@ui/LoadingBoundary";
import ErrorBoundary from "../../../../ErrorBoundary";

const SuspenseSidePanel = ({ children }: { children: React.ReactNode }) => (
  <ErrorBoundary>
    <LoadingBoundary>{children}</LoadingBoundary>
  </ErrorBoundary>
);

export default SuspenseSidePanel;
